import React, { FC } from 'react';
import { getImageField } from '../../../utils/getImageFields';
import Picture from '../../@shared/picture';
import { TMediaElement } from '../types/cardCarousel.types';

const MediaElement: FC<TMediaElement> = (props) => {
  const { mobileImage, desktopImage, thumbnailImgSrc, useVideo, hasWideCard, isWide, isEE } = props;
  return (
    <Picture
      editorialImageProps={{
        mobileImage: getImageField(mobileImage, thumbnailImgSrc || '', useVideo),
        desktopImage: getImageField(desktopImage, thumbnailImgSrc || '', useVideo),
        cssClassImageEl: `card-carousel__image-wrapper--image ${isEE ? 'card-carousel__image-wrapper--no-margin-bottom' : ''}`,
        desktopTransformation: hasWideCard ? 'Size1000' : 'Size500',
        mobileTransformation: 'Size300',
        alt: `${isWide ? desktopImage?.value?.alt : mobileImage?.value?.alt}`,
        isVideoThumbnail: useVideo,
      }}
    />
  );
};

export default MediaElement;
